import React from "react"
import moment from "moment"
// import { userInfo } from "utils"
import { Query } from "react-apollo"
import { Link } from "react-router-dom"
import { Row, Col, Card, Badge, Alert, CardBody, CardHeader } from "reactstrap"
import { Spinner } from "components/spinner"
import {
  maintainServiceStatusTypes,
  maintainServiceStatusTypesClass,
  findTypeValueByKey
} from "utils/types"
import { GET_ANNOUNCEMENT_LIST } from "../gql"

const DashboardContainer = () => {
  // const { role: userRole } = userInfo()

  const renderAnnouncementItem = (item, key) => {
    if (key < 5) {
      return (
        <Row className="mb-3" key={key}>
          <Col md={2} className="mb-2">
            <Link
              to={`/announcement/detail/${item.id}`}
              className="text-white btn btn-success"
            >
              <i className={"text-white mdi mdi-bell-outline"} />
            </Link>
          </Col>
          <Col md={7} className="mb-2">
            <h5 className="content-text">{item.title}</h5>
            <div className="text-muted font-12 ml-auto">
              {item.content.substr(0, 25)} . . .
            </div>
          </Col>
          <Col md={3}>{moment(item.startTime).format("YYYY-MM-DD")}</Col>
        </Row>
      )
    }
    return null
  }

  // eslint-disable-next-line no-unused-vars
  const renderMaintainDevice = (maintainService, index) => {
    if (index < 5) {
      return (
        <Row className="mb-4" key={index}>
          <Col md={2} xs={2}>
            <Link
              to={`device/maintain-service/${maintainService.companyDevice.id}`}
              className="text-white btn btn-success"
            >
              <i className="text-white ti ti-hummer" />
            </Link>
          </Col>
          <Col md={7} xs={7}>
            <h5 className="content-text">{maintainService.device.name}</h5>
            <div className="text-muted font-12 ml-auto">
              {maintainService.description}
            </div>
          </Col>
          <Col md={3} xs={3}>
            <Badge
              style={{ fontSize: "14px" }}
              color={findTypeValueByKey(
                maintainServiceStatusTypesClass,
                maintainService.status
              )}
            >
              {findTypeValueByKey(
                maintainServiceStatusTypes,
                maintainService.status
              )}
            </Badge>
          </Col>
        </Row>
      )
    }
    return null
  }

  return (
    <>
      <Row>
        <Col xs={12} sm={6}>
          <Card>
            <CardHeader style={{ background: "#00ACC1", color: "#FFF" }}>
              公告
            </CardHeader>
            <CardBody style={{ maxHeight: "60vh", overflowY: "scroll" }}>
              <Query query={GET_ANNOUNCEMENT_LIST}>
                {({ loading, error, data }) => {
                  if (loading) {
                    return <Spinner />
                  }

                  if (error) {
                    return <Alert color="danger">錯誤訊息：{`${error}`}</Alert>
                  }

                  if (data?.announcements?.data?.length <= 0) {
                    return <Alert color="dark">目前無任何公告資訊</Alert>
                  }
                  return data?.announcements?.data?.map((item, key) =>
                    renderAnnouncementItem(item, key)
                  )
                }}
              </Query>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DashboardContainer
